import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Router from "./router";
import "./services/i18n";
import { initialiseApplicationMonitoring } from "./services/application-monitoring-adapter";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallbackWithReload from "./features/Common/components/ErrorFallbackWithReload";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

initialiseApplicationMonitoring();

export const sharedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={sharedQueryClient}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary FallbackComponent={ErrorFallbackWithReload}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
